<div class="crm-modal-content crm-page-wrapper">
  <div class="modal-header">
    <div class="modal-title">
      <ng-template #thenBlock>
        <h2>Add User</h2>
      </ng-template>
      <ng-template #elseBlock>
        <h2>User Edit</h2>
      </ng-template>
      <div *ngIf="isAdd === 'Add'; then thenBlock; else elseBlock"></div>
    </div>
    <a class="close" (click)="cancelDialog(false)">&times;</a>
  </div>

  <div class="modal-body">
    <div [hidden]="addUserFormGroup" class="loader">loader</div>
    <form *ngIf="addUserFormGroup" #form="ngForm" [formGroup]="addUserFormGroup" (ngSubmit)="handleAdminUser(form)" class="form" novalidate>
      <div class="row">
        <!-- Left -->
        <div class="col-md-5 offset-md-1 col-sm-12">
          <div class="form-group row">
            <!-- <label class="col-md-12" for="type">First Name</label> -->
            <div class="col-md-12">
              <input
                autocomplete="off"
                formControlName="firstName"
                name="firstName"
                type="text"
                class="form-control"
                placeholder="First Name"
                tabindex="1"
              />
              <errors [on]="(form.submitted || addUserFormGroup.get('firstName').touched) && addUserFormGroup.get('firstName').invalid">
                Enter First Name
              </errors>
            </div>
          </div>
          <div class="form-group row">
            <!-- <label class="col-md-12" for="type">Last Name</label> -->
            <div class="col-md-12">
              <input
                autocomplete="off"
                formControlName="lastName"
                name="lastName"
                type="text"
                class="form-control"
                placeholder="Last Name"
                maxlength="50"
                tabindex="2"
              />
              <errors [on]="(form.submitted || addUserFormGroup.get('lastName').touched) && addUserFormGroup.get('lastName').invalid">
                Enter Last Name
              </errors>
            </div>
          </div>
          <div class="form-group row">
            <!-- <label class="col-md-12" for="type">Designation</label> -->
            <div class="col-md-12">
              <input
                autocomplete="off"
                formControlName="designation"
                name="designation"
                type="text"
                class="form-control"
                placeholder="Designation"
                tabindex="3"
              />
              <errors [on]="(form.submitted || addUserFormGroup.get('designation').touched) && addUserFormGroup.get('designation').invalid">
                Enter Designation
              </errors>
            </div>
          </div>
          <div class="form-group row">
            <!-- <label class="col-md-12" for="type">Email Address</label> -->
            <div class="col-md-12">
              <input
                ng-disabled="isAdd === 'Add'"
                autocomplete="off"
                formControlName="email"
                name="email"
                type="text"
                class="form-control email"
                placeholder="Email Address"
                maxlength="50"
                tabindex="4"
              />

              <errors [on]="(form.submitted || addUserFormGroup.get('email').touched) && addUserFormGroup.get('email').invalid">
                <span
                  [hidden]="
                    !addUserFormGroup.controls.email.errors?.required || (!form.submitted && !addUserFormGroup.controls.email.touched)
                  "
                >
                  Enter Email
                </span>
                <span
                  [hidden]="!addUserFormGroup.controls.email.errors?.email || (!form.submitted && !addUserFormGroup.controls.email.touched)"
                >
                  Invalid
                </span>
                <span
                  [hidden]="
                    !addUserFormGroup.controls.email.errors?.emailAvailable || (!form.submitted && !addUserFormGroup.controls.email.touched)
                  "
                >
                  Email Already Exists!</span
                >
              </errors>
            </div>
          </div>
        </div>
        <!-- Right -->
        <div class="col-md-5 offset-md-1 col-sm-12">
          <div class="form-group">
            <h3>Roles</h3>
            <ul class="w-100 role" formArrayName="roles">
              <li class="form-check checkbox" *ngFor="let role of addUserFormGroup['controls'].roles.controls; let i = index">
                <input
                  id="role-{{ i + 1 }}"
                  class="form-check-input"
                  (change)="onChange(dialogParams.roles[i].description, i)"
                  type="checkbox"
                  [formControlName]="i"
                />
                <label class="form-check-label" for="role-{{ i + 1 }}">
                  {{ dialogParams.roles[i].description }}
                </label>
              </li>
            </ul>
            <!-- <errors [on]="(userRoleSelected)"> -->
            <errors [on]="(form.submitted || addUserFormGroup.get('roles').touched) && addUserFormGroup.get('roles').invalid">
              Select atleast one role
            </errors>
          </div>
        </div>
      </div>

      <div class="modal-footer row">
        <div class="col-md-11 text-right">
          <div class="form-group row" [hidden]="addAdminUserSuccessStatus !== 'success'">
            <div class="col-md-12">
              <div class="alert alert-success" role="alert ">User Saved Successfully</div>
            </div>
          </div>
          <div class="form-group row" [hidden]="addAdminUserSuccessStatus !== 'error'">
            <div class="col-md-12">
              <div class="alert alert-danger" role="alert ">Server Error</div>
            </div>
          </div>
          <button value="handler">
            {{ isAdd === 'Add' ? 'Save' : 'Update' }}
          </button>
          <button type="button" (click)="reset(form)">Clear</button>
        </div>
      </div>
    </form>
  </div>
</div>
